import { Button, Flex, HStack, Stack, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { API } from "config"
import { toaster } from "config"
import useUser from "hooks/useUser"
import { useState } from "react"

export default function Contact(){

    const user = useUser()

    const [ mobile, setMobile ] = useState()
    const [ email, setEmail ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()

    const mobileDefaultValue = `+${user.data?.mobile_country_code}${user.data?.mobile}`

    const handleSubmit = async () => {
        if(!email && !mobile) return
        setLoading(true)
        setErrors(false)

        try{
            await API.put('/me', { email, mobile })
            toaster.create({ title: 'Dados atualizados', type: 'success' })
            user.refetch()
            setMobile(null)
            setEmail(null)
        }catch(err){
            setErrors(err.response.data?.message)
            toaster.create({ title: 'Não foi possível atualizar. Tente novamente.', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Box loading={user.isLoading} h="auto">
        <Text children="Informações de contato:" size="xs" color="GrayText" mb={4} />

        <Stack gap={4}>

            <HStack alignItems="flex-start" gap={4}>

                <Form.Text 
                    required
                    label="Endereço de e-mail:"
                    defaultValue={user.data?.email}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    error={errors?.email}
                    disabled={loading}
                    variant="ghost"
                />

                <Form.Mobile 
                    required
                    label="Celular/Whatsapp:"
                    value={mobileDefaultValue || mobile}
                    disabled={loading}
                    onChange={e => setMobile(e.target.value)}
                    error={errors?.mobile}
                    variant="ghost"
                />

            </HStack>

            <UI.Show visible={!!mobile || !!email}>
                <UI.Alert size="sm">Se você alterar seu endereço de e-mail ou telefone celular, será necessário realizar a confirmação novamente.</UI.Alert>
                <Button colorPalette="orange" loading={loading} onClick={handleSubmit}>Salvar informações</Button>
            </UI.Show>

        </Stack>
    </UI.Box>
    )
}